import { useMemo } from 'react';

import { useGetAllStudents } from '../api/get-all-students';

/**
 * Hook to fetch students and create a mapping of student IDs to student names
 * @param studentIds - Array of student IDs to map
 * @returns Object with:
 *  - studentsMap: Record of studentId -> student name
 *  - isLoading: Whether data is being fetched
 *  - students: Full array of all students (for additional data if needed)
 */
export const useStudentsByIds = (studentIds: string[]) => {
  const { data: allStudents = [], isLoading } = useGetAllStudents();

  const studentsMap = useMemo(() => {
    const map: Record<string, string> = {};

    // Filter to only include students that are in the studentIds array
    const relevantStudents = allStudents.filter((student) =>
      studentIds.includes(student._id),
    );

    // Create map of ID -> name (using firstName and lastName)
    relevantStudents.forEach((student) => {
      map[student._id] = `${student.firstName} ${student.lastName}`;
    });

    return map;
  }, [allStudents, studentIds]);

  return {
    studentsMap,
    isLoading,
    students: allStudents,
  };
};
